import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NoDataBaseComponent } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-no-data',
  templateUrl: './no-data.component.html',
  imports: [TranslatePipe],
  styleUrls: ['./no-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataWebComponent extends NoDataBaseComponent {}
